module.exports = __webpack_public_path__ + "img/190-7fa51b.png";